import toDegree from 'helpers/toDegree'

/**
 * Calculates tilt based on distance, camera height, and scene height.
 * @param {Object} args - Object to be deconstructed which contains arguments.
 * @param {Number} args.distance
 * @param {Number} args.cameraHeight
 * @param {Number} args.sceneHeight
 * @return {Number}
 */

export default function calculateTilt({ distance, cameraHeight, sceneHeight }) {
  return toDegree(Math.atan((sceneHeight - cameraHeight) / distance))
}



// WEBPACK FOOTER //
// ./src/helpers/calculations/calculateTilt.js